import type { Reducer } from 'redux';
import type { ProposalState } from '@makemydeal/dr-dash-types';
import {
    GET_PROPOSAL_LIST_REQUEST,
    GET_PROPOSAL_LIST_SUCCESS,
    GET_PROPOSAL_LIST_FAILURE,
    TOGGLE_PROPOSAL_LIST_DRAWER,
    CREATE_PROPOSAL_REQUEST,
    CREATE_PROPOSAL_SUCCESS,
    CREATE_PROPOSAL_FAILURE,
    GET_PROPOSAL_PREVIEW_REQUEST,
    GET_PROPOSAL_PREVIEW_SUCCESS,
    GET_PROPOSAL_PREVIEW_FAILURE,
    DELETE_PROPOSAL_FAILURE,
    DELETE_PROPOSAL_REQUEST,
    DELETE_PROPOSAL_SUCCESS,
    COPY_PROPOSAL_FAILURE,
    COPY_PROPOSAL_REQUEST,
    COPY_PROPOSAL_SUCCESS,
    UPDATE_PROPOSAL_FAILURE,
    UPDATE_PROPOSAL_REQUEST,
    UPDATE_PROPOSAL_SUCCESS,
    GET_PROPOSAL_FAILURE,
    GET_PROPOSAL_REQUEST,
    GET_PROPOSAL_SUCCESS
} from '../actionTypes/proposalActionTypes';

const initialState: ProposalState = {
    list: {
        value: [],
        isLoading: false,
        isError: false
    },
    preview: {
        value: '',
        isLoading: false,
        isError: false
    },
    showProposalListDrawer: false,
    create: {
        isLoading: false,
        isError: false,
        isSuccess: false,
        proposal: undefined
    },
    delete: {
        isLoading: false,
        isError: false,
        isSuccess: false
    },
    copy: {
        isLoading: false,
        isError: false,
        isSuccess: false
    },
    update: {
        isLoading: false,
        isError: false,
        isSuccess: false
    },
    current: {
        isLoading: false,
        isError: false,
        isSuccess: false,
        proposal: undefined
    }
};

export type ProposalReducer = Reducer<ProposalState>;

export const reducer: ProposalReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PROPOSAL_LIST_REQUEST:
            return {
                ...state,
                list: {
                    ...state.list,
                    isLoading: true,
                    isError: false
                }
            };
        case GET_PROPOSAL_LIST_SUCCESS:
            return {
                ...state,
                list: {
                    value: action.payload,
                    isLoading: false,
                    isError: false
                }
            };
        case GET_PROPOSAL_LIST_FAILURE:
            return {
                ...state,
                list: {
                    value: [],
                    isLoading: false,
                    isError: true
                }
            };
        case TOGGLE_PROPOSAL_LIST_DRAWER:
            return {
                ...state,
                showProposalListDrawer: action.payload.show
            };
        case GET_PROPOSAL_PREVIEW_REQUEST:
            return {
                ...state,
                preview: {
                    ...state.preview,
                    isLoading: true,
                    isError: false
                }
            };
        case GET_PROPOSAL_PREVIEW_SUCCESS:
            return {
                ...state,
                preview: {
                    value: action.payload.data.html,
                    isLoading: false,
                    isError: false
                }
            };
        case GET_PROPOSAL_PREVIEW_FAILURE:
            return {
                ...state,
                preview: {
                    value: '',
                    isLoading: false,
                    isError: true
                }
            };
        case CREATE_PROPOSAL_REQUEST:
            return {
                ...state,
                create: {
                    isLoading: true,
                    isError: false,
                    isSuccess: false,
                    proposal: undefined
                }
            };
        case CREATE_PROPOSAL_SUCCESS:
            return {
                ...state,
                create: {
                    isLoading: false,
                    isError: false,
                    isSuccess: true,
                    proposal: action.payload
                }
            };
        case CREATE_PROPOSAL_FAILURE:
            return {
                ...state,
                create: {
                    isLoading: false,
                    isError: true,
                    isSuccess: false,
                    proposal: undefined,
                    errorMessage: action.payload?.response?.message
                }
            };
        case DELETE_PROPOSAL_REQUEST: {
            return {
                ...state,
                delete: {
                    isLoading: true,
                    isError: false,
                    isSuccess: false
                }
            };
        }
        case DELETE_PROPOSAL_SUCCESS:
            return {
                ...state,
                delete: {
                    isLoading: false,
                    isError: false,
                    isSuccess: true
                }
            };
        case DELETE_PROPOSAL_FAILURE:
            return {
                ...state,
                delete: {
                    isLoading: false,
                    isError: true,
                    isSuccess: false
                }
            };
        case COPY_PROPOSAL_REQUEST: {
            return {
                ...state,
                copy: {
                    isLoading: true,
                    isError: false,
                    isSuccess: false
                }
            };
        }
        case COPY_PROPOSAL_SUCCESS:
            return {
                ...state,
                copy: {
                    isLoading: false,
                    isError: false,
                    isSuccess: true
                }
            };
        case COPY_PROPOSAL_FAILURE:
            return {
                ...state,
                copy: {
                    isLoading: false,
                    isError: true,
                    isSuccess: false
                }
            };
        case UPDATE_PROPOSAL_REQUEST: {
            return {
                ...state,
                update: {
                    isLoading: true,
                    isError: false,
                    isSuccess: false
                }
            };
        }
        case UPDATE_PROPOSAL_SUCCESS:
            return {
                ...state,
                update: {
                    isLoading: false,
                    isError: false,
                    isSuccess: true,
                    proposal: action.payload
                }
            };
        case UPDATE_PROPOSAL_FAILURE:
            return {
                ...state,
                update: {
                    isLoading: false,
                    isError: true,
                    isSuccess: false,
                    errorMessage: action.payload?.response?.message
                }
            };
        case GET_PROPOSAL_REQUEST: {
            return {
                ...state,
                current: {
                    isLoading: true,
                    isError: false,
                    isSuccess: false,
                    proposal: undefined
                }
            };
        }
        case GET_PROPOSAL_SUCCESS:
            return {
                ...state,
                current: {
                    isLoading: false,
                    isError: false,
                    isSuccess: true,
                    proposal: action.payload
                }
            };
        case GET_PROPOSAL_FAILURE:
            return {
                ...state,
                current: {
                    isLoading: false,
                    isError: true,
                    isSuccess: false,
                    proposal: undefined
                }
            };
        default:
            return state;
    }
};
